import React from 'react';
import { Page } from '../../Page';
import { Dot } from './Dot';
import { DotsWrapper } from './DotsStyles';

interface IProps {
  currentPage: Page;
  pages: string[];
}

export const Dots: React.FC<IProps> = (props) => {
  const { currentPage, pages } = props;

  return (
    <DotsWrapper>
      {pages.map((page, index) => (
        <Dot key={index} index={index} currentPage={pages.indexOf(currentPage)} />
      ))}
    </DotsWrapper>
  );
};
